type EquatableValue = { isEqualTo(other: unknown): boolean };

export const areEqual = (value: unknown, other: unknown): boolean => {
  return isEquatable(value) && value.isEqualTo(other);
};

export const unorderedArraysAreEqual = (left: readonly unknown[], right: readonly unknown[]): boolean => {
  if (left.length !== right.length) return false;

  const unmatchedRight = [...right];

  return left.every((leftValue) => {
    const matchedIndex = unmatchedRight.findIndex((rightValue) => areEqual(leftValue, rightValue));
    if (matchedIndex === -1) return false;

    unmatchedRight.splice(matchedIndex, 1);
    return true;
  });
};

const isEquatable = (value: unknown): value is EquatableValue => {
  return (
    value !== null &&
    value !== undefined &&
    typeof value === "object" &&
    "isEqualTo" in value &&
    typeof (value as { isEqualTo?: unknown }).isEqualTo === "function"
  );
};
